import {
	SafeArea,
	StatusbarStyle as SafeAreaStatusbarStyle,
} from 'capacitor-plugin-safe-area';
import mitt from 'mitt';

// plugin's methods
const methods = [
	'getSafeAreaInsets',
	'getStatusBarHeight',
	'setImmersiveNavigationBar',
	'unsetImmersiveNavigationBar',
	'removeAllListeners',
];

// plugin's listeners
const emitter = mitt();
const events = [
	'safeAreaChanged',
];

SafeArea.removeAllListeners();

events.forEach(event => {
	SafeArea.addListener(event, data => {
		emitter.emit(event, data);
	});
});

export function useSafeAreaNative () {
	// methods
	const api = methods.reduce((api, name) => {
		api[name] = SafeArea[name];
		return api;
	}, {});

	// custom add listener
	function addListener (event, callback) {
		emitter.on(event, callback);
		return () => emitter.off(event, callback);
	}

	// custom remove all listeners
	function removeAllListeners () {
		emitter.all.clear();
	}

	return {
		...api,
		addListener,
		removeAllListeners,
	};
};

export const StatusbarStyle = SafeAreaStatusbarStyle;
